module.exports = new __parcel__URL__("bossfight_clock_icon.76987941.png").toString();